import DataTable from 'libs/kd_data_table/data-table';

export default class extends DataTable {
  constructor(data) {
    let options = {
      dataset_name: 'courseworks',

      table_properties: {
        name: 'InstructorCourseworkTable',
        creatable: { enabled: true },
        paginatable: { enabled: true },
        searchable: { enabled: true },
        timezone: data.timezone
      },

      columns: [{
        property: 'order',
        width: 'number_short',
        sortable: {
          type: 'number'
        }
      },

      {
        name: Kadenze.I18n.n('Coursework'),
        property: 'name',
        width: 'name',
        hideable: false,
        editable: {
          type: 'text'
        },
        sortable: {
          type: 'string'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.due_date'),
        property: 'due_date_string',
        width: 'date_long',
        editable: {
          type: 'date'
        },
        sortable: {
          type: 'date'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.visible_on'),
        property: 'visible_on_string',
        width: 'date_long',
        editable: {
          type: 'date'
        },
        sortable: {
          type: 'date'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.submission_window_start'),
        property: 'start_date_string',
        width: 'date_long',
        editable: {
          type: 'date'
        },
        sortable: {
          type: 'date'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.submission_window_end'),
        property: 'end_date_string',
        width: 'date_long',
        editable: {
          type: 'date'
        },
        sortable: {
          type: 'date'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.weight'),
        property: 'weight',
        width: 'percent',
        editable: {
          type: 'complex_number'
        },
        sortable: {
          type: 'number'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.policy'),
        property: 'policy',
        width: 'legend',
        sortable: {
          type: 'string'
        }
      },

      {
        name: Kadenze.I18n.t('dict.table.status'),
        property: 'status',
        editable: {
          type: 'dropdown',
          dropdown_options: ['published', 'draft']
        },
        sortable: {
          type: 'string'
        }
      }],

      column_properties: {
        hideable: { enabled: true },
        sortable: { enabled: true },
        editable: { enabled: true },
      },

      row_properties: {
        removable: { enabled: true },
        draggable: {
          enabled: true,
          update_url: data.sort_course_coursework_index_path,
          callbacks: {
            mousedown: function (e, $tbody) {
              if (data.adaptive) {
                e.stopImmediatePropagation();
                Kadenze.UIUtil.confirmAction('Changing the order of the existing coursework in an adaptive course will alter the suggested due dates for students. Are you sure you want to continue?', function () {
                  $tbody.find('.kd-data-table__sort-handle').off('mousedown');
                }, null);
              }
            }
          }
        },
        data_url: data.course_coursework_index_path,
        actions: 4
      }
    };

      // Cleaning data before sending to data table to init
    let cols = [];

    if(data.adaptive){
      cols = ['order','name','status','weight','policy'];
    } else {
      cols = ['order','name','status','visible_on_string','due_date_string','start_date_string','end_date_string','weight','policy'];
    }

    if(!data.gradebook_enabled) {
      cols = _.reject(cols, function(col) { return col == 'policy' || col == 'weight'; });
    }

    options.columns = _.reject(options.columns, function(col) { return !_.contains(cols, col.property); });

    let hidden_cols = ['start_date_string', 'end_date_string'];

    options.column_properties.hideable.default_columns = _.difference(cols, hidden_cols);

    options.date_cols = _.reject(cols, function(col) { return !s.endsWith(col, '_string'); });

    let el = document.getElementById('coursework_index');

    super(data, el, options);

    this.$el = $(el);
    this.course_id = $('#course_id').val();

    this.gradingPolicyData = JSON.parse($('#course_grade_breakdown_json').val());

    _.map(this.gradingPolicyData, function(data) {
      return data.borderColor = data.backgroundColor;
    });

    this.gradingTooltipTextColor = '#FDFDFD';
    this.gradingTooltipTextFont = '\'Roboto\', sans-serif';

    this.gradingPolicyChartScales = {
      yAxes: [{
        stacked: true,
        gridLines: {
          color: this.gradingTooltipTextColor
        },
      }],
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          color: this.gradingTooltipTextColor
        },
        ticks: {
          stepSize: 20,
          beginAtZero: true,
          fontColor: this.gradingTooltipTextColor
        }
      }]
    };

    this.bindData(data);
  }

  bindData(data) {
    this.adaptive = data.adaptive;
    this.new_course_coursework_path = data.new_course_coursework_path;
  }

  prepRowData(data){
    if(data.type() == 'ExternalAssignment') {
      this.actions('5');
    }

    data.weight(data.weight() + '%');

    _.each(this.config.date_cols, function (date_field) {
      let value = ko.isObservable(data[date_field]) ? data[date_field]() : null;
      if(_.isNull(value)){
        data[date_field] = ko.observable('');
      }
    });
  }

  initBreakdownChart(tooltip, self, title) {
    let $stackedBarChartElement = $('#'+tooltip.UUID()).find('.js-grading-policy-chart');

    new Chart($stackedBarChartElement, {
      type: 'horizontalBar',
      data: {
        labels: [],
        datasets: self.gradingPolicyData
      },

      options: {
        maintainAspectRatio: false,
        scales: self.gradingPolicyChartScales,
        title: {
          display: true,
          position: 'bottom',
          text: title,
          fontSize: 17,
          fontColor: self.gradingTooltipTextColor,
          fontFamily: self.gradingTooltipTextFont
        },

        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 12,
            reverse: false,
            fontSize: 12,
            fontColor: self.gradingTooltipTextColor,
            fontFamily: self.gradingTooltipTextFont
          }
        },

        tooltips: {
          titleSpacing: 0,
          xPadding: 15,
          callbacks: {
            label: function(tooltipItem, data){
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.xLabel + '%';
            }
          }
        }
      }
    });
  }

  editWeightTooltipParams() {
    return { context: 'EditWeight', order: 1, end: true };
  }

  breakdownTooltipParams(self, row) {
    let title = row.policy() + ': ' + (
      isNaN(parseInt(row.policy_weight())) ?
        'Unassigned' :
        `${row.policy_weight()}%`
    );

    return {
      onShow: function(tooltip) {
        self.initBreakdownChart(tooltip, self, title);
      }
    };
  }

  copyCoursework(cw) {
    let copyPrompt = 'Copy this coursework? This action could take up to a minute';
    cw.copyRow(cw, cw.cloner_coursework_path(), copyPrompt);
  }

  previewCoursework(cw) {
    const previewOptions = { preview: true, exit_path: encodeURI(window.location.pathname) };
    window.location = Kadenze.Routes.course_coursework_path(cw.course_id(), cw.id(), previewOptions);
  }

  removeCoursework(cw, evt) {
    let deletePrompt = 'Are you sure you want to delete this coursework from the course?';
    cw.removeRow(cw, evt, deletePrompt);
  }

  cleanRowSortingData(row, arr){
    return { 'courseworks': arr };
  }

  cleanRowEditingData(row, data) {
    let cleanedData = {};

    data.status = data.status.toLowerCase();
    data.weight = data.weight.replace('%','');

    delete data.grade_breakdown;

    _.each(this.config.date_cols, function (date_field) {
      data[date_field] = Kadenze.Util.getMomentDateFromObservable(
          row[date_field]
        ).utc()
         .format(
           I18n.t('date.formats.js_default_with_zone')
         )
    });

    cleanedData.coursework = data;

    return cleanedData;
  }
}
